export const isFirefox = () =>
  window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1 ||
  "MozUserSelect" in window.getComputedStyle(document.body);

export const isLocalhost = () => window.origin?.startsWith("http://localhost");

export const getDocumentSelection = () => document.getSelection();

export const clearDocumentSelection = () =>
  document.getSelection()?.removeAllRanges();
